module.exports = __webpack_public_path__ + "static/media/saskia.385faf0b.jpg";